export const INSTITUTION_DATETIME_FORMATS = {
    declineReport: 'MMM D, YYYY h:mm A',
};

/**
 * Format a UTC datetime value for display in the institution timezone.
 * Mirrors the global formatDate helper: moment.utc(date).tz(institutionTimezone).
 */
export function formatInstitutionDatetime({
    moment,
    timezone,
    date,
    format = INSTITUTION_DATETIME_FORMATS.declineReport,
    emptyValue = '-',
}) {
    if (!date || !timezone || !moment.utc(date).isValid()) {
        return emptyValue;
    }

    return moment.utc(date).tz(timezone).format(format);
}
